import * as type from './constants';

export const changeLayout = (layout) => ({
  type: type.CHANGE_LAYOUT,
  payload: layout,
});

export const changeLayoutWidth = (width) => ({
  type: type.CHANGE_LAYOUT_WIDTH,
  payload: width,
});

export const changeSidebarTheme = (theme) => ({
  type: type.CHANGE_SIDEBAR_THEME,
  payload: theme,
});

export const changeSidebarType = (sidebarType, isMobile) => ({
  type: type.CHANGE_SIDEBAR_TYPE,
  payload: { sidebarType, isMobile },
});

export const changeTopbarTheme = (topbarTheme) => ({
  type: type.CHANGE_TOPBAR_THEME,
  payload: topbarTheme,
});

export const showRightSidebarAction = (isOpen) => ({
  type: type.SHOW_RIGHT_SIDEBAR,
  payload: isOpen,
});

export const showSidebar = (isOpen) => ({
  type: type.SHOW_SIDEBAR,
  payload: isOpen,
});

export const toggleLeftMenu = (isOpen) => ({
  type: type.TOGGLE_LEFT_MENU,
  payload: isOpen,
});

export const loadingRequest = () => ({
  type: type.LOADING_REQUEST,
});

export const loadingSuccess = () => ({
  type: type.LOADING_SUCCESS,
});

export const initData = (payload) => ({
  type: type.INIT_DATA,
  payload,
});

export const refreshTokenRequest = (payload, callback) => ({
  type: type.REFRESH_TOKEN_REQUEST,
  payload,
  callback,
});

export const setLogoImage = (payload) => ({
  type: type.SET_LARGE_LOGO_IMAGE,
  payload,
});
